import { useTranslation } from "@roastery/i18n";
import { UiLabelsProvider } from "@roastery/ui";
import type { ReactNode } from "react";

/**
 * The three words `packages/ui` says on its own, in the language this application is running in
 * (US-37.8, UX-24).
 *
 * <p>Before this, every dialog's × announced itself as "Close" to a screen reader — in Polish and
 * in German too, because the label was a literal in `dialog.tsx`. It is one prop rather than
 * ninety-seven because the button is drawn by the component, not by the screens.
 */
export function UiLabels({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <UiLabelsProvider
      labels={{
        close: t("common.close"),
        previous: t("common.previous"),
        next: t("common.next"),
        table: t("common.scrollableTable"),
      }}
    >
      {children}
    </UiLabelsProvider>
  );
}
